import React, {useState} from 'react';
import ReactDOM from "react-dom/client";
import {ToasterProvider, useToaster} from "../../global-components/toaster.jsx";
import {__, _nonce, _solea_get_local_groups} from "../../../../assets/javascripts/library.js";
import AllParticipants from "./all-participants.jsx";
import LocalGroupParticipants from "./localgroup-participants.jsx";
import ParticipationGroupParticipants from "./participationgroup-participants.jsx";

function EditParticipant({link, participant, event}) {
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    const [formData, setFormData] = useState({
        id: participant.id || '',
        firstname: participant.firstname || '',
        nickname: participant.nickname || '',
        lastname: participant.lastname || '',
        send_coppy_to_my_mail: true,
        arrival_eating: participant.arrival_eating || '',
        departure: participant.departure || '',
        arrival: participant.arrival || '',
        departure_eating: participant.departure_eating || '',
        participant_group: participant.participant_group || '',
        amount_paid: participant.amount_paid || '',
        amount: participant.amount || '',
        eating_habit: participant.eating_habit || '',
        allergies: participant.allergies || '',
        intolerances: participant.intolerances || '',
        medication: participant.medication || '',
        swimming_permission: participant.swimming_permission || '',
        advanced_first_aid: participant.advanced_first_aid || '',
        birthday: participant.birthday || '',
        street: participant.street || '',
        number: participant.number || '',
        zip: participant.zip || '',
        city: participant.city || '',
        local_group: participant.local_group || '',
        email_1: participant.email_1 || '',
        telefon_1: participant.telefon_1 || '',
        contact_person: participant.contact_person || '',
        email_2: participant.email_2 || '',
        telefon_2: participant.telefon_2 || '',
        notices: participant.notices || '',
    });


    const { showToast } = useToaster();
    const handleSubmit = () => {
        const response = fetch("/wp-json/solea/event-details/print-page/edit-participant/save", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                formData,
                solea_nonce: _nonce(),
                'link': link
            }),
        })
            .then((res) => res.json())
            .then((data) => {
                const container = document.getElementById('solea_event_details_content');
                const root = ReactDOM.createRoot(container);

                switch (link) {
                    case 'all_participants':
                        root.render(
                            <ToasterProvider>
                                <div id="solea_event_group_contents">
                                    <AllParticipants link={link} result={data.result} toast_message={data.message} />
                                </div>
                            </ToasterProvider>
                        );
                        break;
                    case 'localgroup_participants':
                        root.render(
                            <ToasterProvider>
                                <div id="solea_event_group_contents">
                                    <LocalGroupParticipants link={link} result={data.result} toast_message={data.message} />
                                </div>
                            </ToasterProvider>
                        );
                        break;
                    case 'participationgroup_participants':
                        root.render(
                            <ToasterProvider>
                                <div id="solea_event_group_contents">
                                    <ParticipationGroupParticipants link={link} result={data.result} toast_message={data.message} />
                                </div>
                            </ToasterProvider>
                        );
                        break;

                }
            });
    };

    return (
        <div>
            <div class="solea-page">
                <h3>{__('Participant data', 'solea')}</h3>
                <table>
                    <tr>
                        <td>{__('Name', 'solea')}:</td>
                        <td>
                            <input
                                type="text"
                                defaultValue={participant.firstname}
                                name="firstname"
                                onChange={handleChange}
                                />
                            (
                            <input
                                type="text"
                                defaultValue={participant.nickname}
                                name="nickname"
                                onChange={handleChange}
                            />
                            )
                            <input
                                type="text"
                                defaultValue={participant.lastname}
                                name="lastname"
                                onChange={handleChange}
                            />
                        </td>
                    </tr>

                    <tr>
                        <td>
                            {__('Arrival', 'solea')}:
                        </td>
                        <td>
                            <input
                                type="date"
                                defaultValue={participant.arrival}
                                name="arrival"
                                onChange={handleChange}
                            />

                            <select name="arrival_eating" defaultValue={participant.arrival_eating} onChange={handleChange} >
                                <option Value="1">{__('Before dinner', 'solea')}</option>
                                <option value="2">{__('Before lunch', 'solea')}</option>
                                <option value="3">{__('Before breakfast', 'solea')}</option>
                                <option value="4">{__('For evening round / No meal on arrival day', 'solea')}</option>
                            </select>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            {__('Departure', 'solea')}:
                        </td>
                        <td>
                            <input
                                type="date"
                                defaultValue={participant.departure}
                                name="departure"
                                onChange={handleChange}
                            />
                            <select name="departure_eating" defaultValue={participant.departure_eating} onChange={handleChange} >
                                <option Value="1">{__('After breakfast', 'solea')}</option>
                                <option value="2">{__('After lunch', 'solea')}</option>
                                <option value="3">{__('After dinner', 'solea')}</option>
                                <option value="4">{__('Before breakfast', 'solea')}</option>
                            </select>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            {__('Participation group', 'solea')}:
                        </td>
                        <td>
                            <select name="participant_group" defaultValue={participant.participant_group} onChange={handleChange} >
                                <option Value="participant">{__('Participant', 'solea')}</option>
                                <option value="volunteer">{__('Volunteer', 'solea')}</option>
                                <option value="team">{__('Team', 'solea')}</option>
                                <option value="other">{__('Other', 'solea')}</option>
                            </select>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            {__('Amount', 'solea')}:
                        </td>
                        <td colSpan="2">
                            <input
                                type="text"
                                defaultValue={participant.amount_paid}
                                name="amount_paid"
                                onChange={handleChange}
                            /> Euro /
                            <input
                                type="text"
                                defaultValue={participant.amount}
                                name="amount"
                                onChange={handleChange}
                            /> Euro
                        </td>
                    </tr>
                </table>
            </div>

            <div class="solea-page">
                <h3>{__('Personal data', 'solea')}</h3>

                <table>
                    <tr>
                        <td>{__('Eating habits', 'solea')}:</td>
                        <td>
                            <select name="eating_habit" defaultValue={participant.eating_habit} onChange={handleChange} className="sb_large">
                                <option Value="vegan">{__('Vegan', 'solea')}</option>
                                <option value="vegetarian">{__('Vegetarian', 'solea')}</option>
                                <option value="meat">{__('Meat', 'solea')}</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td>{__('Allergies', 'solea')}:</td>
                        <td>
                            <input
                                type="text"
                                defaultValue={participant.allergies}
                                name="allergies"
                                className="tb_large"
                                onChange={handleChange}
                            />
                        </td>
                    </tr>

                    <tr>
                        <td>{__('Intolerances', 'solea')}:</td>
                        <td>
                            <input
                                type="text"
                                defaultValue={participant.intolerances}
                                name="intolerances"
                                className="tb_large"
                                onChange={handleChange}
                            />
                        </td>
                    </tr>

                    <tr>
                        <td>{__('Medications', 'solea')}:</td>
                        <td>
                            <input
                                type="text"
                                defaultValue={participant.mediaction}
                                name="medication"
                                className="tb_large"
                                onChange={handleChange}
                            />
                        </td>
                    </tr>

                    <tr>
                        <td>{__('Swimming permission', 'solea')}</td>
                        <td>
                            <select name="swimming_permission" defaultValue={participant.swimming_permission} onChange={handleChange} className="sb_large">
                                <option Value="none">{__('No permission', 'solea')}</option>
                                <option value="partial">{__('My child is allowed to bathe but CANNOT SWIM', 'solea')}</option>
                                <option value="complete">{__('My child is allowed to bathe and can swim', 'solea')}</option>
                            </select>
                        </td>
                    </tr>

                    <tr>
                        <td>{__('Advanced first aid', 'solea')}</td>
                        <td>
                            <select name="advanced_first_aid" defaultValue={participant.advanced_first_aid} onChange={handleChange} className="sb_large">
                                <option Value="0">{__('Advanced first aid is declined', 'solea')}</option>
                                <option value="1">{__('Advanced first aid is confirmed', 'solea')}</option>
                            </select>
                        </td>
                    </tr>

                    <tr>
                        <td>{__('Notes', 'solea')}:</td>
                        <td>
                            <textarea
                                name="notices"
                                defaultValue={participant.notices}
                                onChange={handleChange}
                                className="tb_large"
                            />
                        </td>
                    </tr>

                    <tr>
                        <td>{__('Birthday', 'solea')}:</td>
                        <td>
                            <input
                                type="date"
                                defaultValue={participant.birthday}
                                name="birthday"
                                className="tb_large"
                                onChange={handleChange}
                            />
                        </td>
                    </tr>

                    <tr>
                        <td>{__('Address', 'solea')}:</td>
                        <td>
                            <input
                                type="text"
                                defaultValue={participant.street}
                                name="street"
                                onChange={handleChange}
                            />
                            <input
                                type="text"
                                defaultValue={participant.number}
                                name="number"
                                className="tb_small"
                                onChange={handleChange}
                            /><br />
                            <input
                                type="text"
                                defaultValue={participant.zip}
                                name="zip"
                                className="tb_small"
                                onChange={handleChange}
                            />
                            <input
                                type="text"
                                defaultValue={participant.city}
                                name="city"
                                onChange={handleChange}
                            />
                        </td>
                    </tr>

                    <tr>
                        <td>{__('Local group', 'solea')}:</td>
                        <td>
                            <select name="local_group" defaultValue={participant.local_group} onChange={handleChange} className="sb_large">
                                <option value="0">{__('No registered local group', 'solea')}</option>
                                {_solea_get_local_groups().map((local_group, index) => (
                                    <option value={local_group.id}>{local_group.name}</option>)
                                )}

                            </select>
                        </td>
                    </tr>

                    <tr>
                        <td>{__('E-Mail', 'solea')}:</td>
                        <td>
                            <input
                                type="email"
                                defaultValue={participant.email_1}
                                name="email_1"
                                onChange={handleChange}
                                className="tb_large"
                            />
                        </td>
                    </tr>

                    <tr>
                        <td>{__('Telephone', 'solea')}:</td>
                        <td>
                            <input
                                type="text"
                                defaultValue={participant.telefon_1}
                                name="telefon_1"
                                onChange={handleChange}
                                className="tb_large"
                            />
                        </td>
                    </tr>
                </table>
            </div>

            <div class="solea-page">
                <h3>{__('Emergency contact', 'solea')}</h3>

                <table>
                    <tr>
                        <td>{__('Contact person', 'solea')}:</td>
                        <td>
                            <input
                                type="text"
                                defaultValue={participant.contact_person}
                                name="contact_person"
                                className="tb_large"
                                onChange={handleChange}
                            />
                        </td>
                    </tr>

                    <tr>
                        <td>{__('E-Mail', 'solea')}:</td>
                        <td>
                            <input
                                type="email"
                                defaultValue={participant.email_2}
                                name="email_2"
                                className="tb_large"
                                onChange={handleChange}
                            />
                        </td>
                    </tr>

                    <tr>
                        <td>{__('Telephone', 'solea')}:</td>
                        <td>
                            <input
                                type="text"
                                defaultValue={participant.telefon_2}
                                name="telefon_2"
                                className="tb_large"
                                onChange={handleChange}
                            />
                        </td>
                    </tr>
                </table>
            </div>
            <p><button className="button solea-button" onClick={handleSubmit}>{__('Save', 'solea')}</button></p>
        </div>
    )
}

export default EditParticipant;